import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { BOOKING_URL, clients, isBookingConfigured } from '../data/proposal';
type IntroStatementProps = {
  onOpenConcept: () => void;
};
export function IntroStatement({
  onOpenConcept
}: IntroStatementProps) {
  return <section aria-labelledby="intro-title" className="max-w-[480px] text-ink" data-id="element-105" data-mp="12xk25gupolve">
      <p className="font-mono text-[11px] font-medium tracking-[0.22em] text-teal" data-id="element-106" data-mp="12vh01ygab2ab">FOLLOWING OUR CONVERSATION</p>
      <h1 id="intro-title" className="mt-4 text-[34px] font-semibold leading-[1.05] tracking-[-0.035em] lg:text-[42px]" data-id="element-107" data-mp="p054xpy7v9sv">
        We took the liberty of <span className="text-graphite" data-id="element-108" data-mp="f0o2dhe9hc14">creating a Snak for you.</span>
      </h1>

      <div className="mt-6 space-y-3 text-[16px] leading-[1.6] text-graphite" data-id="element-109" data-mp="jy63ilm1emyk">
        <p data-id="element-110" data-mp="29dm8rpwuboj6">
          Following our meeting, we created a short <span className="text-ink" data-id="element-111" data-mp="29e5gyewouyk0">Study Data Snak</span> inspired by the latest German
          MINT results for Poteligeo®.
        </p>
        <p data-id="element-112" data-mp="4c6gldudwmp7">
          Not because we presume to know your brand, market or priorities better than you do — but to demonstrate how we make{' '}
          <strong className="font-semibold text-ink" data-id="element-113" data-mp="3vhfy0h4bbsn7">complex scientific knowledge short, sharp and engaging</strong> for busy
          HCPs.
        </p>
        <p data-id="element-114" data-mp="92wlyr2t8pjw">Please explore it as an inspiration, not a recommendation.</p>
        <p data-id="element-115" data-mp="93oh60shwl9n">
          We’d love the opportunity to show you more of our work and explore where Snakker could make a difference for Kyowa
          Kirin.
        </p>
      </div>

      <div className="mt-8 flex flex-col items-start gap-4" data-id="element-116" data-mp="3ckwx2f3nxb1q">
        <a href={isBookingConfigured ? BOOKING_URL : '#booking-link-not-configured'} target={isBookingConfigured ? '_blank' : undefined} rel={isBookingConfigured ? 'noopener noreferrer' : undefined} onClick={e => {
        if (!isBookingConfigured) e.preventDefault();
      }} title={isBookingConfigured ? undefined : 'Booking link not yet configured — set BOOKING_URL in data/proposal.ts'} className="group inline-flex items-center gap-2.5 whitespace-nowrap rounded-full bg-navy px-6 py-3.5 text-[15px] font-medium text-white shadow-[0_10px_24px_-12px_rgba(30,58,95,0.7)] transition-[background-color,transform] duration-150 ease-out hover:bg-ink active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy" data-id="element-117" data-mp="3qj4ns5a3vg4g">
          Book a 20-minute introduction
          <ArrowRightIcon size={16} strokeWidth={2} className="transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-118" data-mp="3gue3fxlbmzf2" />
        </a>
        <button type="button" onClick={onOpenConcept} className="group inline-flex items-center gap-1.5 text-[14px] font-medium text-navy transition-colors duration-150 hover:text-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy" data-id="element-119" data-mp="3ku4pxp3tetds">
          Explore the concept &amp; other ideas
          <ArrowRightIcon size={15} strokeWidth={2} className="transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-120" data-mp="2pmm0zboov361" />
        </button>
      </div>

      <p className="mt-8 text-[12.5px] text-graphite/80" data-id="element-121" data-mp="2glegpxj0c2uy">
        Experience with teams at {clients.join(' · ')} and others.
      </p>

      <p className="mt-6 text-[11px] leading-snug text-graphite/60" data-id="element-122" data-mp="2bpgwhg4miccw">
        Illustrative concept based on publicly available information.
        <br data-id="element-123" data-mp="21x1ewjx8npsj" />
        Idea, concept &amp; creative direction © Snakker™ 2026 · Confidential &amp; proprietary.
      </p>
    </section>;
}